import Box from '@mui/material/Box'
import ClientsDrawersProvider from 'components/context/ClientsDrawersProvider'
import { ADMIN_NAV_DRAWER_WIDTH } from 'const'
import { LayoutHeader } from 'features/Layout/components/LayoutHeader/LayoutHeader'
import { useCheckAuthorizationAndRedirect } from 'hooks/useCheckAuthorizationAndRedirect'
import { Outlet } from 'react-router-dom'
import { UserType } from 'types'
import { LayoutMain } from '../../../features/Layout/components/LayoutMain/LayoutMain'
import AdminDrawerContent from '../../drawer/AdminDrawerContent'
import DrawerHeaderFiller from '../../drawer/common/DrawerHeaderFiller'
import { NavigationDrawer } from '../../drawer/navigation/NavigationDrawer'
import { AdminHeaderContent } from '../components/AdminHeaderContent'

const AdminPageLayout = () => {
  const redirect = useCheckAuthorizationAndRedirect([UserType.ADMIN, UserType.ANALYST])
  if (redirect) {
    return <>{redirect}</>
  }

  return (
    <ClientsDrawersProvider>
      <Box display="flex">
        <LayoutHeader>
          <AdminHeaderContent />
        </LayoutHeader>

        <NavigationDrawer width={ADMIN_NAV_DRAWER_WIDTH}>
          <AdminDrawerContent />
        </NavigationDrawer>
        <LayoutMain>
          <DrawerHeaderFiller />
          <Box
            paddingX={2}
            paddingTop={2}
            flexGrow={1}
            className="ag-theme-alpine"
            display="flex"
            flexDirection="column"
            style={{ fontSize: '1rem' }}
          >
            <Outlet />
          </Box>
        </LayoutMain>
      </Box>
    </ClientsDrawersProvider>
  )
}

export default AdminPageLayout
